import { EncryptStorage } from 'encrypt-storage';
export const encryptStorage = new EncryptStorage('ip-base-key', {});
